var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "fill:#403f40",
    d: "M16.295 16.71 11.5 11.916 6.705 16.71a1 1 0 0 1-.7.293.994.994 0 0 1-.707-.293 1 1 0 0 1 0-1.415l4.791-4.793L5.298 5.71a1 1 0 0 1 0-1.415.991.991 0 0 1 1.41 0l4.795 4.794 4.795-4.794a.991.991 0 0 1 1.41 0 1 1 0 0 1 0 1.415l-4.793 4.792 4.793 4.793a1 1 0 0 1 0 1.415 1 1 0 0 1-.7.293.994.994 0 0 1-.713-.293z",
    "data-name": "Path 11605"
  })));
};
export default SvgClear;